
const apiFiles = require.context('./', true, /apis.js$/)
const apis={}
apiFiles.keys().forEach(key => {
  const apiFile=apiFiles(key).default
  apis[apiFile.name]=apiFile
})
export default {
  ...apis
}



// WEBPACK FOOTER //
// ./src/api/index.js